import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputSwitch, InputPicklist, Layout } from '../../components';
import BaseView from '../base/base-view.component'; 
import Model from './journalgroup-model';  //editable..
import JournalgroupdetailList from '../journalgroupdetail/journalgroupdetail-list.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class JournalgroupView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseView history={this.props.history} 
                model={Model} onLoad={this.onLoad} disableCard>              
                            
                <Layout history={this.props.history} content={[
                    {caption: 'Details', child: 
                    <>
                        <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                        <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                        {AppService.isAppFullVersion() &&
                        <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                        }
                    </>
                    },

                    {caption: 'Jurnal Group Details', child:
                    this.state.datarow.id > 0 && 
                        <JournalgroupdetailList history={this.props.history} root={this.props.root} journalgroupId={this.state.datarow.id} actions={['view']} disableBackButton  disableCard/> 
                    },
                    ]}
                    
                /> 
            </BaseView>
        );
    }
}